import React from 'react';
import './pagination.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  maxVisiblePages = 3 
}) => {
  if (totalPages <= 1) return null;

  // Функция для отображения номеров страниц
  const renderPageNumbers = () => {
    const pageNumbers = [];
        
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Корректируем startPage, если endPage достиг максимума
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Кнопка для первой страницы
    if (startPage > 1) {
      pageNumbers.push(
        <button
          key={1}
          onClick={() => onPageChange(1)}
          className="page-number"
        >
          1
        </button>
      );
      if (startPage > 2) {
        pageNumbers.push(<span key="start-ellipsis" className="page-ellipsis">...</span>);
      }
    }

    // Номера страниц
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => onPageChange(i)}
          className={`page-number ${currentPage === i ? 'active' : ''}`}
        >
        {i}
        </button>
      );
    }

    // Кнопка для последней страницы
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<span key="end-ellipsis" className="page-ellipsis">...</span>);
      }
      pageNumbers.push(
        <button
          key={totalPages}
          onClick={() => onPageChange(totalPages)}
          className="page-number"
        >
        {totalPages}
        </button>
      );
    }

    return pageNumbers;
    };

    return (
        <div className="pagination">
            <button 
                onClick={() => onPageChange(1)}
                disabled={currentPage === 1}
                className="pagination-btn first-last"
                title="Первая страница"
            >
            </button>
            <button 
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="pagination-btn prevBtn"
                title="Предыдущая страница"
            >
            </button>
            
            <div className="page-numbers">
                {renderPageNumbers()}
            </div>

            <button 
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="pagination-btn nextBtn"
                title="Следующая страница"
            >
            </button>
            <button 
                onClick={() => onPageChange(totalPages)}
                disabled={currentPage === totalPages}
                className="pagination-btn first-last"
                title="Последняя страница"
            >
            </button>
        </div>
    );
};
export default Pagination;